import { Moon, Sun, Monitor } from 'lucide-react'
import { useTheme, type Theme } from '@/hooks/use-theme'

/**
 * Theme toggle button component
 * Cycles through system, light, and dark modes
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  // Cycle through: system → light → dark → system
  const cycleTheme = () => {
    const nextTheme: Record<Theme, Theme> = {
      system: 'light',
      light: 'dark',
      dark: 'system',
    }
    setTheme(nextTheme[theme])
  }

  const labels: Record<Theme, string> = {
    system: 'System theme (click to switch to light)',
    light: 'Light theme (click to switch to dark)',
    dark: 'Dark theme (click to switch to system)',
  }

  return (
    <button
      onClick={cycleTheme}
      className="rounded-lg p-2 transition-colors hover:bg-slate-100 dark:hover:bg-slate-800"
      aria-label={labels[theme]}
      title={labels[theme]}
    >
      {theme === 'system' ? (
        <Monitor className="h-5 w-5 text-slate-600 dark:text-slate-400" />
      ) : theme === 'dark' ? (
        <Moon className="h-5 w-5 text-slate-300" />
      ) : (
        <Sun className="h-5 w-5 text-amber-500" />
      )}
    </button>
  )
}
